/*
        SUMMARY
            0 - Imports
            1 - Const / Variables
            2 - Functions
*/

/*---------------------/ 0 - Imports /-------------------*/
require('./home-mobile/modules/contato-dropdown');
document.addEventListener('DOMContentLoaded', () => window.HomeContatoDropdown?.init());

/*---------------------/ 1 - Const - Variables /-------------------*/
let esgSwiper = null;
let esgSwiperText = null;

const IS_MOBILE = window.innerWidth <= 992;

let mobileLenis = null;
let rafId = null;

/*---------------------/ 2 - Functions /-------------------*/

let magnetLenis = null;
let magnetRafId = null;
let magnetWheelHandler = null;
let magnetKeyHandler = null;
let magnetTouchStartHandler = null;
let magnetTouchMoveHandler = null;
let magnetTouchEndHandler = null;

function getEsgSectionRevealElements(section) {
    const selectors = [
        '.breadcrumbs',
        '.splash__nav',
        '.plants__ornament',
        '.hero-label',
        '.hero-title',
        '.hero-bottom',
        '.content-card .slide-label',
        '.content-card .headline',
        '.content-card .body-text',
        '.right-panel',
        '.recognition-title',
        '.recognition-logo',
        '.recognition-text',
        '#esg-video .top',
        '#esg-video .play',
        '#esg-video .bottom',
        '.form-eyebrow',
        '.form-title',
        '.form-subtitle',
        '.form-right',
        '.section-scroll',
    ];

    return Array.from(new Set(
        selectors.flatMap((selector) => Array.from(section.querySelectorAll(selector)))
    ));
}

function setEsgSectionInitialState(section) {
    const elements = getEsgSectionRevealElements(section);

    section.classList.remove('is-active');
    if (section.hasAttribute('data-animation')) section.classList.remove('animated-element');
    section.querySelectorAll('[data-animation]').forEach((el) => el.classList.remove('animated-element'));

    if (typeof gsap === 'undefined') {
        elements.forEach((el) => {
            el.style.opacity = '1';
            el.style.transform = 'none';
            el.style.visibility = 'visible';
        });
        return;
    }

    gsap.killTweensOf(elements);
    gsap.set(elements, { autoAlpha: 0, y: 38, clearProps: 'x' });
}

function animateEsgSection(section, immediate = false) {
    const elements = getEsgSectionRevealElements(section);

    section.classList.add('is-active');
    if (section.hasAttribute('data-animation')) section.classList.add('animated-element');
    section.querySelectorAll('[data-animation]').forEach((el) => el.classList.add('animated-element'));

    if (typeof gsap === 'undefined' || !elements.length) return;

    gsap.killTweensOf(elements);
    gsap.fromTo(elements,
        { autoAlpha: 0, y: immediate ? 0 : 38 },
        {
            autoAlpha: 1,
            y: 0,
            duration: immediate ? 0 : 0.85,
            ease: 'power3.out',
            stagger: immediate ? 0 : 0.12,
            overwrite: true,
            clearProps: 'transform,visibility',
        }
    );
}

function updateEsgActiveSection(sections, currentIndex, immediate = false) {
    sections.forEach((section, index) => {
        const isActive = index === currentIndex;

        if (isActive) {
            if (!section.classList.contains('is-active')) {
                animateEsgSection(section, immediate);
                section.dispatchEvent(new CustomEvent('esg:active'));
            }
            return;
        }

        if (section.classList.contains('is-active')) {
            section.dispatchEvent(new CustomEvent('esg:inactive'));
        }
        setEsgSectionInitialState(section);
    });
}

function updateEsgMobileHeaderThemeBySection(section) {
    const header = document.getElementById('header');
    if (!header) return;

    if (window.innerWidth >= 992) {
        header.classList.remove('header-dark');
        return;
    }

    header.classList.toggle('header-dark', !!section && section.id === 'footer');
}

function handleMagnetScroll() {
    const isDesktop = window.innerWidth >= 992;
    const containerSelector = isDesktop ? '#desktop' : '#mobile';
    const sections = Array.from(
        document.querySelectorAll(`${containerSelector} > section, footer`)
    );

    if (!sections.length) return;

    // ─── Defensive: destrói Lenis global (de scrollLenis.js) se existir.
    // Sem isso, duas instâncias Lenis disputam o wheel e o snap "trava".
    if (window.lenis && typeof window.lenis.destroy === 'function' && window.lenis !== magnetLenis) {
        try { window.lenis.destroy(); } catch (e) { /* noop */ }
        window.lenis = null;
    }

    // ─── Limpa instância anterior completamente ───────────────────
    if (magnetLenis) {
        magnetLenis.destroy();
        magnetLenis = null;
    }
    if (magnetRafId) {
        cancelAnimationFrame(magnetRafId);
        magnetRafId = null;
    }

    // Remove todos os listeners antigos antes de adicionar novos
    // (capture: true precisa bater com o addEventListener original — senão não remove)
    if (magnetWheelHandler) window.removeEventListener('wheel', magnetWheelHandler, { passive: false, capture: true });
    if (magnetKeyHandler) window.removeEventListener('keydown', magnetKeyHandler, { capture: true });
    if (magnetTouchStartHandler) window.removeEventListener('touchstart', magnetTouchStartHandler);
    if (magnetTouchMoveHandler) window.removeEventListener('touchmove', magnetTouchMoveHandler);
    if (magnetTouchEndHandler) window.removeEventListener('touchend', magnetTouchEndHandler);

    magnetWheelHandler = null;
    magnetKeyHandler = null;
    magnetTouchStartHandler = null;
    magnetTouchMoveHandler = null;
    magnetTouchEndHandler = null;

    // ─── Nova instância Lenis ─────────────────────────────────────
    magnetLenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: false,   // DESLIGADO — quem controla o wheel é nosso listener
        smoothTouch: false,
        touchMultiplier: isDesktop ? 1 : 0,
        infinite: false,
        autoResize: true,
    });

    function raf(time) {
        if (!magnetLenis) return;
        magnetLenis.raf(time);
        magnetRafId = requestAnimationFrame(raf);
    }
    magnetRafId = requestAnimationFrame(raf);

    let currentIndex = 0;
    let isSnapping = false;
    let scrollLockTimer;
    let lastScrollTime = 0;
    let touchStartY = 0;
    let touchStartX = 0;
    let touchTarget = null;

    function isInsideSelector(target, selector) {
        let el = target instanceof Element ? target : null;
        while (el && el !== document.body) {
            if (el.matches && el.matches(selector)) return true;
            el = el.parentElement;
        }
        return false;
    }

    function goToIndex(index) {
        const clamped = Math.max(0, Math.min(index, sections.length - 1));
        if (clamped === currentIndex && isSnapping) return;
        currentIndex = clamped;
        isSnapping = true;
        clearTimeout(scrollLockTimer);
        updateEsgActiveSection(sections, currentIndex);
        updateEsgMobileHeaderThemeBySection(sections[currentIndex]);

        magnetLenis.scrollTo(sections[currentIndex], {
            offset: 0,
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            lock: true,
            force: true,
            onComplete: () => {
                scrollLockTimer = setTimeout(() => { isSnapping = false; }, 150);
            },
        });

        // Fallback caso onComplete não dispare
        scrollLockTimer = setTimeout(() => { isSnapping = false; }, 1500);
    }

    function syncCurrentIndex() {
        if (!magnetLenis) return;
        const scrollY = magnetLenis.scroll;
        let closest = 0, closestDist = Infinity;
        sections.forEach((section, i) => {
            const dist = Math.abs(scrollY - section.offsetTop);
            if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        currentIndex = closest;
    }

    // ─── Wheel (desktop) ─────────────────────────────────────────
    if (isDesktop) {
        let wheelAccumulator = 0;
        let wheelTimer = null;
        const THRESHOLD = 15;
        const COOLDOWN = 1100;

        magnetWheelHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const now = Date.now();
            if (isSnapping || now - lastScrollTime < COOLDOWN) {
                wheelAccumulator = 0;
                return;
            }

            if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

            wheelAccumulator += e.deltaY;
            clearTimeout(wheelTimer);
            wheelTimer = setTimeout(() => { wheelAccumulator = 0; }, 150);

            if (Math.abs(wheelAccumulator) >= THRESHOLD) {
                const direction = wheelAccumulator > 0 ? 1 : -1;
                wheelAccumulator = 0;

                if (direction > 0 && currentIndex < sections.length - 1) {
                    lastScrollTime = now;
                    goToIndex(currentIndex + 1);
                } else if (direction < 0 && currentIndex > 0) {
                    lastScrollTime = now;
                    goToIndex(currentIndex - 1);
                }
            }
        };

        // capture: true garante que interceptamos antes de qualquer outro handler
        window.addEventListener('wheel', magnetWheelHandler, { passive: false, capture: true });

        // ─── Teclado (desktop) ───────────────────────────────────
        // Setas/PageUp/PageDown/Espaço/Home/End rolam a página nativamente,
        // pulando o goToIndex — a section aparece sem animar. Interceptamos
        // e navegamos pelo mesmo fluxo do wheel.
        magnetKeyHandler = (e) => {
            const target = e.target;
            if (target instanceof Element && target.closest('input, textarea, select, [contenteditable="true"]')) return;

            let targetIndex = null;
            if (e.key === 'ArrowDown' || e.key === 'PageDown' || (e.key === ' ' && !e.shiftKey)) {
                targetIndex = currentIndex + 1;
            } else if (e.key === 'ArrowUp' || e.key === 'PageUp' || (e.key === ' ' && e.shiftKey)) {
                targetIndex = currentIndex - 1;
            } else if (e.key === 'Home') {
                targetIndex = 0;
            } else if (e.key === 'End') {
                targetIndex = sections.length - 1;
            } else {
                return;
            }

            // Bloqueia o scroll nativo mesmo durante o cooldown,
            // senão a página rola sem disparar as animações
            e.preventDefault();

            const now = Date.now();
            if (isSnapping || now - lastScrollTime < COOLDOWN) return;
            if (targetIndex === currentIndex || targetIndex < 0 || targetIndex > sections.length - 1) return;

            lastScrollTime = now;
            goToIndex(targetIndex);
        };

        window.addEventListener('keydown', magnetKeyHandler, { capture: true });
    }

    // ─── Touch (mobile) ──────────────────────────────────────────
    const SWIPE_THRESHOLD = 40;

    magnetTouchStartHandler = (e) => {
        syncCurrentIndex();
        touchStartY = e.touches[0].clientY;
        touchStartX = e.touches[0].clientX;
        touchTarget = e.target;
    };

    magnetTouchMoveHandler = (e) => {
        // Deixa o Swiper receber swipe horizontal sem bloquear o scroll-snap vertical
        const moveY = e.touches[0].clientY;
        const moveX = e.touches[0].clientX;
        const diffY = touchStartY - moveY;
        const diffX = touchStartX - moveX;
        if (Math.abs(diffX) > Math.abs(diffY) && isInsideSelector(touchTarget, '.swiper')) {
            return;
        }
        e.preventDefault();
    };

    magnetTouchEndHandler = (e) => {
        const now = Date.now();
        if (isSnapping || now - lastScrollTime < 1200) return;

        const deltaY = touchStartY - e.changedTouches[0].clientY;
        const deltaX = touchStartX - e.changedTouches[0].clientX;
        // Ignora se o gesto foi predominantemente horizontal dentro de um swiper
        if (Math.abs(deltaX) > Math.abs(deltaY) && isInsideSelector(touchTarget, '.swiper')) return;
        if (Math.abs(deltaY) < SWIPE_THRESHOLD) { goToIndex(currentIndex); return; }

        if (deltaY > 0 && currentIndex < sections.length - 1) {
            lastScrollTime = now;
            goToIndex(currentIndex + 1);
        } else if (deltaY < 0 && currentIndex > 0) {
            lastScrollTime = now;
            goToIndex(currentIndex - 1);
        }
    };

    window.addEventListener('touchstart', magnetTouchStartHandler, { passive: false });
    window.addEventListener('touchmove', magnetTouchMoveHandler, { passive: false });
    window.addEventListener('touchend', magnetTouchEndHandler, { passive: false });

    // NÃO chamar goToIndex(0) aqui. Quando a página carrega scrollY já é 0,
    // então scrollTo(sections[0], {lock:true}) tem delta zero — o Lenis pode
    // pular a animação e nunca disparar onComplete, deixando o lock interno
    // permanente. Isso bloqueia wheel e touch (mas não keydown, que dispara
    // scroll event direto) — exatamente o sintoma "só seta funciona".
    // O navegador já posiciona em scrollY=0 no load; basta sincronizar o índice.
    if (history.scrollRestoration) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    currentIndex = 0;
    sections.forEach(setEsgSectionInitialState);
    updateEsgActiveSection(sections, currentIndex, true);
    updateEsgMobileHeaderThemeBySection(sections[currentIndex]);
}

// Inicializa o player de vídeo inline (suporta MP4 ou iframe do YouTube)
function handleVideo() {
    let videoSection = document.querySelectorAll('.video');

    videoSection.forEach(section => {
        let thumb = section.querySelector('.thumb');
        let playBtn = section.querySelector('.play');
        let video = section.querySelector('.video--file');

        if (!playBtn || !video) return;

        const isIframe = video.tagName === 'IFRAME' || video.dataset.renderType === 'iframe';
        const lightboxHref = isIframe
            ? (video.dataset.originalUrl || video.dataset.embedSrc)
            : video.src;

        const lightbox = GLightbox({
            elements: [{
                href: lightboxHref,
                type: 'video',
                width: 900,
            }],
            autoplayVideos: true,
            skin: 'clean',
            touchNavigation: true,
            closeOnOutsideClick: true,
        });

        // play
        playBtn.addEventListener('click', function (e) {
            e.stopPropagation();

            // YouTube/iframe abre sempre no lightbox (desktop e mobile)
            if (isIframe) {
                lightbox.open();
                return;
            }

            if (IS_MOBILE) {
                lightbox.open();
                return;
            } else {
                playVideo();
            }
        });

        if (!isIframe) {
            // pause (mp4 only)
            video.addEventListener('click', pauseVideo);

            // reseta caso vídeo acabe
            video.addEventListener('ended', resetVideo);
        }

        function playVideo() {
            playBtn.classList.toggle('paused');

            thumb.classList.contains('d-none') ? '' : thumb.classList.add('d-none');

            video.play();
            video.classList.remove('not-clickable');

            section.classList.add('playing');
        }

        function pauseVideo() {
            if (!section.classList.contains('playing'))
                return;

            playBtn.classList.toggle('paused');

            video.pause();
            video.classList.add('not-clickable');
        }

        function resetVideo() {
            section.classList.remove('playing');
            thumb.classList.remove('d-none');
            playBtn.classList.remove('paused');

            video.currentTime = 0;
        }
    })
}

// Inicializa o slider ESG desktop (mobile usa Swiper — initEsgMobileSlider)
function initEsgSlider() {
    document.querySelectorAll('#desktop #esg-slider.hero')
        .forEach(initEsgHeroSlider);
}

// Slider ESG mobile — Swiper igual cultura/espacos da página de empreendimento mobile
function initEsgMobileSlider() {
    const root = document.querySelector('#esg-slider-mobile');
    if (!root) return;

    const swiperEl = root.querySelector('.js-esg-mslider-swiper');
    if (!swiperEl || typeof window.Swiper !== 'function') return;

    const labelEl = root.querySelector('.js-esg-mslider-label');
    const titleEl = root.querySelector('.js-esg-mslider-title');
    const textEl = root.querySelector('.js-esg-mslider-text');
    const currentEl = root.querySelector('.js-esg-mslider-current');

    const updateSlide = (idx) => {
        const data = (window.__esgMobileSlides || [])[idx] || {};
        if (labelEl && data.label != null) labelEl.textContent = data.label;
        if (titleEl && data.headline != null) titleEl.innerHTML = data.headline;
        if (textEl && data.body != null) textEl.textContent = data.body;
        if (currentEl) currentEl.textContent = String(idx + 1);
    };

    const swiper = new window.Swiper(swiperEl, {
        loop: true,
        speed: 700,
        autoplay: false,
        allowTouchMove: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        on: {
            slideChange: (sw) => updateSlide(sw.realIndex),
        },
    });

    root.querySelector('.esg-mslider__prev')
        ?.addEventListener('click', () => swiper.slidePrev());
    root.querySelector('.esg-mslider__next')
        ?.addEventListener('click', () => swiper.slideNext());

    updateSlide(0);
}

// Porta do initSlider do produto (page_product-detail-desk.js)
function initEsgHeroSlider(section) {
    const slideEls = section.querySelectorAll('.slide');
    if (slideEls.length < 1) return;

    const headlineEl = section.querySelector('.headline');
    const bodyEl     = section.querySelector('.body-text');
    const labelEl    = section.querySelector('.slide-label');
    const card       = section.querySelector('.content-card');
    const progItems  = section.querySelectorAll('.prog-item');
    const btnPrev    = section.querySelector('[data-slider-prev]');
    const btnNext    = section.querySelector('[data-slider-next]');

    const slides = Array.from(slideEls).map(el => ({
        label:    el.dataset.label    || '',
        headline: el.dataset.headline || '',
        body:     el.dataset.body     || ''
    }));

    let current = 0;
    let isAnimating = false;
    let autoTimer, progTimeout;

    function startProgressBar() {
        if (!progItems.length || !progItems[current]) return;
        clearTimeout(progTimeout);
        progItems.forEach((item, i) => {
            item.classList.toggle('active', i === current);
            const fill = item.querySelector('.prog-fill');
            if (fill) {
                fill.getAnimations().forEach(a => a.cancel());
                fill.style.width = '0%';
            }
        });
        const fill = progItems[current].querySelector('.prog-fill');
        progTimeout = setTimeout(() => {
            if (fill) fill.animate([{ width: '0%' }, { width: '100%' }], { duration: 6000, fill: 'forwards', easing: 'linear' });
        }, 650);
    }

    function goTo(next, direction = 'forward') {
        if (isAnimating || next === current || next < 0 || next >= slides.length) return;
        isAnimating = true;
        const prev = current;
        current = next;
        const isForward = direction === 'forward';
        const prevSlide = slideEls[prev];
        const nextSlide = slideEls[next];

        if (card) { card.style.opacity = '0'; card.style.transform = 'translateY(22px)'; }

        prevSlide.classList.add('exiting', isForward ? 'forward' : 'backward');
        prevSlide.classList.remove('active');
        nextSlide.classList.add('entering', isForward ? 'forward' : 'backward');

        setTimeout(() => {
            prevSlide.classList.remove('exiting', 'forward', 'backward');
            nextSlide.classList.remove('entering', 'forward', 'backward');
            nextSlide.classList.add('active');
            if (headlineEl && slides[current].headline) headlineEl.innerHTML = slides[current].headline;
            if (bodyEl     && slides[current].body)     bodyEl.textContent  = slides[current].body;
            if (labelEl    && slides[current].label)    labelEl.innerHTML   = slides[current].label;
            startProgressBar();
            setTimeout(() => { if (card) { card.style.opacity = ''; card.style.transform = ''; } }, 120);
            isAnimating = false;
        }, 1100);
    }

    function startAuto() {
        clearInterval(autoTimer);
        if (slides.length < 2) return;
        autoTimer = setInterval(() => goTo((current + 1) % slides.length), 6500);
    }

    function stopAuto() { clearInterval(autoTimer); clearTimeout(progTimeout); }

    btnNext?.addEventListener('click', () => { goTo((current + 1) % slides.length, 'forward');  startAuto(); });
    btnPrev?.addEventListener('click', () => { goTo((current - 1 + slides.length) % slides.length, 'backward'); startAuto(); });
    progItems.forEach(item => {
        item.addEventListener('click', () => {
            const next = parseInt(item.dataset.idx);
            goTo(next, next > current ? 'forward' : 'backward');
            startAuto();
        });
    });

    section.addEventListener('esg:active', () => {
        startProgressBar();
        startAuto();
    });
    section.addEventListener('esg:inactive', stopAuto);
}

// Inicializa todos os componentes
function initAll() {
    handleMagnetScroll();
    handleVideo();
    initEsgSlider();
    initEsgMobileSlider();
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}

